/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Metadata for work blocked by unavailable tenant configuration.
 */
export type EmployeeExecutionConfigurationUnavailableBlocker = {
    /**
     * Deterministic blocker classification.
     */
    category: EmployeeExecutionConfigurationUnavailableBlocker.category;
    /**
     * Sanitized human-readable explanation without raw tool output.
     */
    reason: string;
    /**
     * Tool whose required tenant configuration is unavailable.
     */
    toolName: string;
    /**
     * Stable implementation-owned failure code.
     */
    failureCode: string;
    /**
     * ISO timestamp when the runtime determined that progress was blocked.
     */
    occurredAt: string;
};
export namespace EmployeeExecutionConfigurationUnavailableBlocker {
    /**
     * Deterministic blocker classification.
     */
    export enum category {
        CONFIGURATION_UNAVAILABLE = 'configuration-unavailable',
    }
}

